import { usePortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { useSelectLocked } from 'layoutRenderer/store/selectors';

export function usePortfolioReturnsLegendStatus() {
    const { config } = usePortfolioReturnsConfigSlice();
    const { combineSellsAndShorts } = useSelectAppSettings();
    const locked = useSelectLocked();

    const {
        index1,
        index2,
        hideTotalLegend: hideTotalLegendConfig,
        hideBuyLegend: hideBuyLegendConfig,
        hideSellLegend: hideSellLegendConfig,
        hideShortLegend: hideShortLegendConfig,
        hideIndex1Legend: hideIndex1LegendConfig,
        hideIndex2Legend: hideIndex2LegendConfig,
    } = config;

    const hideBuyLegend = locked && hideBuyLegendConfig;
    const hideTotalLegend = locked && hideTotalLegendConfig;
    const hideSellLegend = locked && hideSellLegendConfig;
    const hideShortLegend =
        (locked && hideShortLegendConfig) || combineSellsAndShorts;
    const hideIndex1Legend = (locked && hideIndex1LegendConfig) || !index1;
    const hideIndex2Legend = (locked && hideIndex2LegendConfig) || !index2;
    const hideLastCol = hideIndex1Legend && hideIndex2Legend;

    const columnCount = countVisible(
        hideTotalLegend,
        hideBuyLegend,
        hideSellLegend,
        hideShortLegend,
        hideLastCol
    );

    const allHidden =
        hideTotalLegend &&
        hideBuyLegend &&
        hideSellLegend &&
        hideShortLegend &&
        hideIndex1Legend &&
        hideIndex2Legend;

    return { allHidden, columnCount };
}

function countVisible(...hiddenValues: boolean[]) {
    let qty = hiddenValues.length;
    for (const hiddenValue of hiddenValues) {
        if (hiddenValue) {
            qty--;
        }
    }
    return qty;
}
